module.exports = __webpack_public_path__ + "img/Brian_King@1x.69ca4055.png";